import React from 'react';

import useTranslate from 'common/I18n/Interpreter';

export const InfoLabel = ({ label = '' }) => {
  const t = useTranslate();

  return (
    <span className="withdrawal-bitcoin__label">
      {t(label)}
      {': '}
    </span>
  );
};
